import React from 'react';

interface SyncStatusBadgeProps {
  syncPercentage: number;
  status: 'healthy' | 'warning' | 'critical';
  syncedDays: number;
  totalDays: number;
}

export const SyncStatusBadge: React.FC<SyncStatusBadgeProps> = ({
  syncPercentage,
  status,
  syncedDays,
  totalDays
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'healthy': return 'bg-green-100 text-green-800 border-green-200';
      case 'warning': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'critical': return 'bg-red-100 text-red-800 border-red-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'healthy': return '✓';
      case 'warning': return '⚠';
      case 'critical': return '✗';
      default: return '?';
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-gray-700">Meter Sync Status</h4>
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusColor()}`}>
          {getStatusIcon()} {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      </div>
      
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Sync Percentage</span>
          <span className="font-medium">{syncPercentage.toFixed(1)}%</span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Synced Days</span>
          <span className="font-medium">{syncedDays}/{totalDays}</span>
        </div>
        
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all duration-300 ${
              status === 'healthy' ? 'bg-green-500' : 
              status === 'warning' ? 'bg-yellow-500' : 'bg-red-500'
            }`}
            style={{ width: `${syncPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};